import React from 'react';
import { useLanguage } from '../contexts/LanguageContext';

/** Full-viewport loader while lazy route chunks load — matches static-page loading treatment. */
export function RouteSuspenseFallback() {
  const { lang } = useLanguage();
  const isAr = lang === 'ar';
  return (
    <div
      className={`min-h-screen flex items-center justify-center bg-cream text-sea-blue ${isAr ? 'font-arabic' : ''}`}
    >
      {isAr ? 'جاري التحميل…' : 'Loading…'}
    </div>
  );
}
